<div class="tab-container">

  <div class="row form-group">
    <label class="control-label col-3">{{'Mã trung tâm' | translate}}</label>
    <div class="col-9">
      <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma">
    </div>

  </div>
  <div class="row form-group">
    <label class="control-label col-3">{{'Tên trung tâm' | translate}}</label>
    <div class="col-9">
      <input type="text" tabIndex="2" class="form-control" placeholder="Tên trung tâm" [(ngModel)]="doituongSelect.Ten">
    </div>
  </div>

  <div class="row form-group">
    <label class="control-label col-3">{{'Địa chỉ' | translate}}</label>
    <div class="col-9">
      <input type="text" tabIndex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DiaChi">
    </div>
  </div>
  <div class="row form-group">
    <label class="control-label col-3">{{'Điện thoại' | translate}}</label>
    <div class="col-9">
      <input type="text" tabIndex="4" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DienThoai">
    </div>
  </div>
  <!--<div class="row form-group">
    <label class="control-label col-3">{{'Liên thông nội bộ' | translate}}</label>
    <div class="col-9">
      <ng-select style="width:100%;"
                 [openOnEnter]="false"
                 [items]="inputlienthongs"
                 bindValue="Id"
                 bindLabel="Ten"
                 notFoundText="Không có dữ liệu"
                 placeholder=""
                 [(ngModel)]="doituongSelect.LT_Noibo">
      </ng-select>
    </div>
  </div>-->
  <div class="row form-group">
    <label class="control-label col-3">{{'Email' | translate}}</label>
    <div class="col-9">
      <input type="text" tabIndex="6" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Email">
    </div>
  </div>
  <div class="row form-group">
    <label class="control-label col-3 ng-binding">{{'Cấp trên' | translate}}</label>
    <div class="col-9">

      <ng-select #slCapTren
                 class="twcollong"
                 autofocus
                 [tabIndex]="3"
                 [openOnEnter]="false"
                 [items]="inputparents"
                 bindValue="Id"
                 bindLabel="Ten"
                 notFoundText="Không có dữ liệu"
                 [searchFn]="comboSearchFn_DV"
                 [(ngModel)]="doituongSelect.CapTrenId">
        <ng-template ng-option-tmp let-item="item">

          <div class="rTableRow">
            <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
            <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
          </div>

        </ng-template>
      </ng-select>

    </div>

  </div>
  <!--<div class="row form-group">
    <label class="control-label col-3 ng-binding">{{'Mã DV_ADMIN' | translate}}</label>
    <div class="col-9">
      <input type="text" tabIndex="7" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DV_ADMIN">
    </div>

  </div>-->





</div>






<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div class="">

  </div>
  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" tabindex="22" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" tabindex="23" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>

